module.exports = __webpack_public_path__ + "img/footer.7c57a45.jpg";